import React from "react";
import GitHubCalendar from "react-github-calendar";
import {Box, Flex, Heading, Image} from '@chakra-ui/react'
import styled from'../Styles/GitHub.module.css'
const GithubCal = () => {
  return (
    <Box style={{background:"#000",color:"#DC143C"}} id='Github' >
    <Heading as="h1"  ml="100px" fontSize={"40px"} fontWeight={"bold"}>GitHub Stats</Heading>
    <Box >
         <GitHubCalendar username="Ashukla011" style={{margin:"auto"}} />
    </Box>

     {/* <Flex justifyContent={"space-around"} gap={'10'} direction={{base:'row',md:'column' ,sm:'column',lg:'row'}} >
     <Image align="center" src="https://github-readme-stats.vercel.app/api?username=Ashukla011&show_icons=true&locale=en" alt="Ashukla011" />
     <Image align="center" src="https://github-readme-streak-stats.herokuapp.com/?user=Ashukla011&" alt="Ashukla011" />
     <Image  src="https://github-readme-stats.vercel.app/api/top-langs?username=Ashukla011&show_icons=true&locale=en&layout=compact" alt="Ashukla011" h={'190'}  />

     </Flex> */}
   
    <div className={styled.gitStats} >
    <div className={styled.box1}>
    <img align="center" src="https://github-readme-stats.vercel.app/api?username=Ashukla011&show_icons=true&locale=en" alt="Ashukla011" />
    </div>
     <div className={styled.box2}>
     <img align="center" src="https://github-readme-streak-stats.herokuapp.com/?user=Ashukla011&" alt="Ashukla011" />
     </div>
    <div className={styled.box3}>
    <img  src="https://github-readme-stats.vercel.app/api/top-langs?username=Ashukla011&show_icons=true&locale=en&layout=compact" alt="Ashukla011"  />
    </div>
    </div>
   
    </Box>
  );
};

export default GithubCal;